export default __webpack_public_path__ + "static/media/app-mint.09108a0e.svg";